<div class="space-y-6">
<section class="surface-elevated p-6" style="opacity: 1; transform: none;">
    <h3 class="mb-4 text-lg font-semibold text-text-primary">{{ 'experts.contact.title' | translate }}</h3>
    <div class="space-y-4">
        @if (expert.phoneNumber) {
        <div class="contact-row">
            <i class="fas fa-phone"></i>
            <div class="min-w-0 flex-1">
                <div class="mb-1 text-xs text-text-muted">{{ 'experts.contact.directCall' | translate }}</div>
                <div class="font-semibold text-text-primary" dir="ltr">{{ expert.phoneNumber }}</div>
            </div>
        </div>
        }
        @if (expert.email) {
        <div class="contact-row">
            <i class="fas fa-envelope"></i>
            <div class="min-w-0 flex-1">
                <div class="mb-1 text-xs text-text-muted">{{ 'experts.contact.email' | translate }}</div>
                <div class="truncate text-sm font-semibold text-text-primary" dir="ltr">{{ expert.email }}</div>
            </div>
        </div>
        }
        @if (expert.website) {
        <div class="contact-row">
            <i class="fas fa-globe"></i>
            <div class="min-w-0 flex-1">
                <div class="mb-1 text-xs text-text-muted">{{ 'experts.contact.website' | translate }}</div>
                <div class="truncate text-sm font-semibold text-text-primary" dir="ltr">
                    <a [href]="expert.website" target="_blank" class="hover:text-primary transition-colors">{{ expert.website }}</a>
                </div>
            </div>
        </div>
        }
    </div>
    <button class="btn btn-primary mt-6 w-full">
        <i class="fas fa-message text-sm"></i>
        {{ 'experts.profile.sendMessage' | translate }}
    </button>
</section>

<section class="surface-elevated p-6" style="opacity: 1; transform: none;">
    <h3 class="mb-4 flex items-center gap-2 text-lg font-semibold text-text-primary">
        <i class="fas fa-target text-sm text-primary"></i>
        {{ 'experts.contact.specializations' | translate }}
    </h3>
    <div class="space-y-2">
        @for (tag of expert.tags; track tag) {
            <div class="list-row">
                <i class="fas fa-circle-check"></i>
                <span>{{ tag }}</span>
            </div>
        } @empty {
            <div class="list-row">
                <i class="fas fa-circle-check"></i>
                <span>{{ 'experts.contact.defaultSpecializations.luxuryResidential' | translate }}</span>
            </div>
            <div class="list-row">
                <i class="fas fa-circle-check"></i>
                <span>{{ 'experts.contact.defaultSpecializations.apartmentsVillas' | translate }}</span>
            </div>
            <div class="list-row">
                <i class="fas fa-circle-check"></i>
                <span>{{ 'experts.contact.defaultSpecializations.investments' | translate }}</span>
            </div>
        }
    </div>
</section>

@if (expert.type !== 'developer' && expert.serviceAreas && expert.serviceAreas.length > 0) {
<section class="surface-elevated p-6" style="opacity: 1; transform: none;">
    <h3 class="mb-4 flex items-center gap-2 text-lg font-semibold text-text-primary">
        <i class="fas fa-map-location-dot text-sm text-primary"></i>
        {{ 'experts.contact.serviceAreas' | translate }}
    </h3>
    <div class="space-y-2">
        @for (area of expert.serviceAreas; track area) {
            <div class="list-row">
                <i class="fas fa-location-dot"></i>
                <span>{{ area }}</span>
            </div>
        }
    </div>
</section>
}

@if (expert.type === 'developer' && expert.commercialRegisterNumber) {
<section class="surface-elevated p-6" style="opacity: 1; transform: none;">
    <h3 class="mb-4 flex items-center gap-2 text-lg font-semibold text-text-primary">
        <i class="fas fa-file-contract text-sm text-primary"></i>
        {{ 'experts.contact.commercialRegister' | translate }}
    </h3>
    <div class="contact-row">
        <i class="fas fa-hashtag"></i>
        <div class="min-w-0 flex-1">
            <div class="mb-1 text-xs text-text-muted">{{ 'experts.contact.commercialRegisterNumber' | translate }}</div>
            <div class="font-semibold text-text-primary" dir="ltr">{{ expert.commercialRegisterNumber }}</div>
        </div>
    </div>
</section>
}

@if (expert.certificatesAndLicenses && expert.certificatesAndLicenses.length > 0) {
<section class="surface-elevated p-6" style="opacity: 1; transform: none;">
    <h3 class="mb-4 flex items-center gap-2 text-lg font-semibold text-text-primary">
        <i class="fas fa-shield-halved text-sm text-primary"></i>
        {{ 'experts.contact.certificates' | translate }}
    </h3>
    <div class="space-y-3">
        @for (cert of expert.certificatesAndLicenses; track cert) {
            <div class="credential-row">
                <i class="fas fa-circle-check"></i>
                <span>{{ cert }}</span>
            </div>
        }
    </div>
</section>
} @else if (expert.type !== 'developer') {
<section class="surface-elevated p-6" style="opacity: 1; transform: none;">
    <h3 class="mb-4 flex items-center gap-2 text-lg font-semibold text-text-primary">
        <i class="fas fa-shield-halved text-sm text-primary"></i>
        {{ 'experts.contact.certificates' | translate }}
    </h3>
    <div class="space-y-3">
        <div class="credential-row">
            <i class="fas fa-circle-check"></i>
            <span>{{ 'experts.contact.defaultCertificates.brokerageLicense' | translate }}</span>
        </div>
        <div class="credential-row">
            <i class="fas fa-circle-check"></i>
            <span>{{ 'experts.contact.defaultCertificates.negotiationCertificate' | translate }}</span>
        </div>
        <div class="credential-row">
            <i class="fas fa-circle-check"></i>
            <span>{{ 'experts.contact.defaultCertificates.brokerAssociation' | translate }}</span>
        </div>
        <div class="credential-row">
            <i class="fas fa-circle-check"></i>
            <span>{{ 'experts.contact.defaultCertificates.digitalMarketing' | translate }}</span>
        </div>
    </div>
</section>
}

@if (expert.responseTimeLabel) {
<section class="surface-elevated border-success/20 bg-success-soft p-6 text-center" style="opacity: 1; transform: none;">
    <i class="fas fa-bolt mx-auto mb-3 block text-3xl text-success"></i>
    <h3 class="mb-2 text-lg font-semibold text-text-primary">{{ 'experts.contact.quickResponse' | translate }}</h3>
    <div class="mb-2 text-3xl font-black text-text-primary" dir="auto">{{ expert.responseTimeLabel }}</div>
    <p class="text-sm leading-relaxed text-text-secondary">{{ 'experts.contact.responseAverage' | translate }}</p>
</section>
}

<section class="surface-elevated border-border-primary bg-primary-soft p-6 text-center" style="opacity: 1; transform: none;">
    <i class="fas fa-shield-halved mx-auto mb-3 block text-3xl text-primary"></i>
    <h3 class="mb-2 text-lg font-semibold text-text-primary">{{ 'experts.profile.certifiedBroker' | translate }}</h3>
    <p class="text-sm font-medium leading-relaxed text-text-secondary">{{ 'experts.contact.certifiedDescription' | translate }}</p>
</section>
</div>
